/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Model `OrderRequestMessageModel`.
 */
@endpoint('deliveryRequestMessage')
export default class OrderRequestMessageModel extends BaseModel {
  /**
   * Properties.
   */
  @prop({ transient: true })
  id?: number;

  @prop()
  collectId?: number;

  @prop()
  deliveryId?: number;

  @prop()
  deliveryRequestId: number;

  @prop({ transient: true })
  isDeleted?: boolean;

  @prop({ transient: true })
  isRead?: boolean;

  @prop()
  message: string;

  @prop()
  orderType?: 'DELIVERY' | 'COLLECT';

  @prop({ transient: true })
  recordDate?: string;

  @prop({ transient: true })
  source?: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<OrderRequestMessageModel>) {
    super(data);
  }
}
